// extracted by mini-css-extract-plugin
export default {"PageStart":"Teams_PageStart__Begtz","Card":"Teams_Card__bMvy5","CustomPageBar":"Teams_CustomPageBar__vpvCR"};